(function () {

  'use strict';

  function pxSignInProfilePrintersList(
    PrinterListPOSTPaging, PrinterListService, $location, $rootScope, $timeout, EventServiceEvents
  ) {
    return {
      restrict: 'EA',
      scope: {
        goProfile: '=goProfile',
        onDeviceConfig: '=onDeviceConfig',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/signInProfileProperties/signInProfilePrintersList/signInProfilePrintersList.template.html',
      link: function (scope) {

        const embedPrinterStatus = true;
        scope.loading = true;
        scope.loadedPrinters = [];

        scope.printerPaging = new PrinterListPOSTPaging();
        scope.printerPaging.pagingCriteria.types = 'NETWORK,VIRTUAL';
        scope.printerPaging.pagingCriteria.pageSize = 10;
        scope.printerPaging.pagingCriteria.page = 0;

        scope.getPageOfPrinters = function (page) {
          if (angular.isDefined(page)) {
            scope.printerPaging.pagingCriteria.page = page;
          }
          scope.loading = true;
          scope.goProfile.getPrinters(scope.printerPaging, embedPrinterStatus).then(function (printers) {
            scope.totalPages = printers.page.totalPages;
            if (printers.list) {
              setTargetUrl(printers.list);
              setIcon(printers.list);
              scope.loadedPrinters = printers.list;
            } else {
              scope.loadedPrinters = [];
            }
            scope.loading = false;
          }).catch(function(error){
            scope.loading = false;
          });
        };

        function setTargetUrl(printers) {
          const target = $location.absUrl().split('goConfiguration/');
          angular.forEach(printers, function (printer) {
            printer.info.icon = 'icon-printer';
            printer.targetUrl = target[0] + 'printerProperties/' + printer.customProperties.id;
          });
        }

        function setIcon(printers) {
          angular.forEach(printers, function (printer) {
            printer.icon = 'icon-printer';
          });
        }

        scope.textSearch = function () {
          scope.printerPaging.pagingCriteria.match = scope.searchString;
          $timeout(function () {
            scope.getPageOfPrinters(0);
          }, 50);
        };

        (function () {
          setListeners();
          scope.getPageOfPrinters(0);
        })();

        // TOOLTIP STUFF

        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch (tooltipScope) {
              case 'statement':
                tooltip(position, context);
                break;
            }
          } else {
            clearTooltip();
          }
        };

        function tooltip(position, title) {
          switch (title) {
            case 'SUCCESS':
              title = 'Success';
              break;
            case 'FAILED':
              title = 'FAILED';
              break;
            case 'UNKNOWN':
              title = 'Unknown';
              break;
          }
          scope.clearTooltip();
          scope.tooltipContent = {
            title: title,
            type: 'statement'
          };
          scope.tooltipObject = {
            position: { left: position.startX, top: position.startY + 20 }
          };
        }

        function clearTooltip() {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

        function checkIfUpdateIsRequiredInMenu(printer) {
          return !printer.info.onDeviceTestState ||
            printer.info.onDeviceTestState === 'UNKNOWN' || printer.info.onDeviceTestState === 'FAILED';
        }

        // Directly open a contextual popup dialog

        scope.openContext = function (event, context, menuOption) {
          scope.closeAllMenues();
          $timeout(function  () {
            scope.selectedContextMenuItem  =  menuOption;
            scope.contextContentPosition = { left: event.clientX, top: event.clientY };
            scope.contextPosition = { left: event.clientX, top: event.clientY };
            scope.contextContent = context;
            scope.context = context;
            scope.auxiliaries = {
              tenant: scope.tenant
            };
          }, 50);
        };

        scope.closeAllMenues = function () {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem = null;
          scope.contextContentPosition = null;
          scope.contextPosition = null;
          scope.contextContent = null;
          scope.context = null;
          scope.auxiliaries = null;
        };

        scope.openGoProfileMenu = function (event, printer) {
          scope.closeAllMenues();
          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                {
                  title: 'ChangeSignInProfile', name: printer.info.name, selected: false, type: 'selectSignInProfile', breaker: false,
                  disabled: scope.me.isSystemObserver()
                },
                {
                  title: 'RemoveSignInProfile', name: printer.info.name, selected: false, type: 'printerRemoveSignInProfile', breaker: true,
                  disabled: scope.me.isSystemObserver()
                },
                {
                  title: 'VerifySignInProfile', name: printer.info.name, selected: false, type: 'testSignInProfileOnPrinter', breaker: true,
                  warning: !!checkIfUpdateIsRequiredInMenu(printer), disabled: scope.me.isSystemObserver()
                },
                {
                  title: 'PrinterProperties', selected: false, type: 'link', breaker: false,
                  href: '/admin/#/printerProperties/' + printer.customProperties.id + '?printerSection=printixGo'
                }
              ],
              context: printer,
              icon: 'icon-printer',
              sizeClass: 'size115',
              type: 'ALLROUND'
            };
            scope.menuContent.context.name = printer.info.name;
            scope.menuSpecs = {
              position: { left: event.clientX, top: event.clientY },
              type: 'ALLROUND'
            };
          }, 50);
        };

        scope.openContextMenu = function (selectedContextMenuItem, contextPosition, menu) {
          scope.closeAllMenues();
          $timeout(function  () {
            scope.selectedContextMenuItem = selectedContextMenuItem;
            scope.contextPosition = contextPosition;
            scope.context = menu ? menu.context : null;
            scope.resource = scope.tenant;
            scope.auxiliaries = {
              tenant: scope.tenant,
              printer: menu ? menu.context : null,
              goProfile: scope.goProfile
            };
          }, 50);
        };

        // UPDATING PRINTER

        function getPrinterByUrl(printerId) {
          PrinterListService.getPrinterByURL(printerId).then(function (printer) {
            const loadedPrinter = scope.loadedPrinters.find(p => p.info._links.self.href === printer.info._links.self.href);
            if (loadedPrinter) {
              loadedPrinter.info = printer.info;
            }
          }).catch(function(error){});
        }

        // EVENTS

        function setListeners() {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_REMOVED, function (name, data) {
            if (scope.network._links.self.href === data.network) {
              if (scope.loadedPrinters.find(printer => printer.info._links.self.href === data.printer)) {
                scope.getPageOfPrinters(0);
              }
            }
          });
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_UPDATE, function (name, data) {
            if (scope.loadedPrinters.find(printer => printer.info._links.self.href === data.printer)) {
              getPrinterByUrl(data.printer);
            }
          });
        }

        const refreshGoPrinterListListener = $rootScope.$on('REFRESH_GO_PRINTER_LIST', function (name, data) {
          scope.getPageOfPrinters(0);
        });

        const removeGoFromPrinterListener = $rootScope.$on('REMOVE_GO_FROM_PRINTER', function (name, data) {
          if (scope.loadedPrinters.find(printer => printer.info._links.self.href === data.printer.info._links.self.href)) {
            scope.getPageOfPrinters(0);
          }
        });

        scope.$on('$destroy', function () {
          refreshGoPrinterListListener();
          removeGoFromPrinterListener();
        });

      }
    };
  }

  pxSignInProfilePrintersList.$inject = [
    'PrinterListPOSTPaging', 'PrinterListService', '$location', '$rootScope', '$timeout', 'EventServiceEvents'
  ];

  angular
    .module('printix-admin')
    .directive('pxSignInProfilePrintersList', pxSignInProfilePrintersList);

})();
